import { buildSecondaryMainSectionIconVariant } from '../iconButton/variants/secondaryMainSection';
import { ButtonVariantType } from '../variants';
export const getIconSecondaryMainSectionStyles = (FOUNDATIONS, FONT) => {
    return {
        [ButtonVariantType.ICON_SECONDARY_MAIN_SECTION]: buildSecondaryMainSectionIconVariant(FOUNDATIONS),
    };
};
//# sourceMappingURL=iconSecondaryMainSection.js.map